import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual, filterArray } from 'helpers/utils'


export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { config } = props;
    const data = ((row?.extendedResults?.length > 0))
        ? row?.extendedResults
        : undefined

    const configSectors = config?.intermediates.filter(item => item.sector.posIntermediate === 'F')
    return (
        <>
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th style={{ textAlign: "left" }}><Label data="HeaderSplits" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderRaceTime" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderRank" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderTimeDifference" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderSplitTime" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderSplitRank" /></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        config.intermediates.map((item, key) => {
                            let configSplit = (item?.sector?.code !== undefined)
                                ? <Label data={`Header${item?.sector?.code}`} />
                                : <span> --</span>

                            let splitDistance = (item?.sector?.valueIntermediate !== undefined)
                                ? (item?.sector?.value >= 1000)
                                    ? <span> {item?.sector?.valueIntermediate}<Label data='LabelM' /></span>
                                    : <span> {item?.sector?.valueIntermediate}<Label data='LabelKm' /></span>
                                : ''

                            let header = item?.sector?.posIntermediate === 'F' && item?.sector?.code === 'RUN'
                                ? <Label data="HeaderFinish" />
                                : <span>{configSplit} {splitDistance}</span>

                            let res = findArray(data, { er_type: [item?.sector?.code], er_code: ['INTERMEDIATE'], er_pos: [item?.sector?.posIntermediate] })
                            let resLap = findArray(data, { er_type: [item?.sector?.code], er_code: ['LAP'], er_pos: [item?.sector?.posIntermediate] })
                            let resSector = findArray(data, { er_type: [item?.sector?.code], er_code: ['SECTOR'], er_pos: [item?.sector?.posIntermediate] })

                            return (
                                <tr key={'expanded_' + row.participant.code + '_' + key}>
                                    <td style={{ textAlign: "left" }}><strong>{header}</strong></td>
                                    <td style={{ textAlign: "right" }}>{res.er_value}</td>
                                    <td style={{ textAlign: "right" }}>{res.er_rank}</td>
                                    <td style={{ textAlign: "right" }}>{res.er_diff}</td>
                                    <td style={{ textAlign: "right" }}>{resLap.er_value ? resLap.er_value : resSector.er_value}</td>
                                    <td style={{ textAlign: "right" }}>{resLap.er_rank ? resLap.er_rank : resSector.er_rank}</td>
                                </tr>
                            )

                        })
                    }
                </tbody>
            </table>

            <table className="table table-detail">
                <thead>
                    <tr>
                        <th style={{ textAlign: "left" }}><Label data="HeaderSegments" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderRaceTime" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderRank" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderTimeDifference" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderSegmentTime" /></th>
                        <th style={{ textAlign: "right" }}><Label data="HeaderSegmentRank" /></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        configSectors?.map((item, key) => {
                            let resInt = findArray(data, { er_type: [item?.sector?.code], er_code: ['INTERMEDIATE'], er_pos: ['F'] })
                            let resSec = findArray(data, { er_type: [item?.sector?.code], er_code: ['SECTOR'], er_pos: ['F'] })
                            let configSplit = (item?.sector?.code !== undefined)
                                ? <Label data={`Header${item?.sector?.code}`} />
                                : <> {item?.sector?.code} </>
                            return (
                                <tr key={'expanded_' + row.participant.code + '_' + key}>
                                    <td style={{ textAlign: "left" }}><strong>{configSplit}</strong></td>
                                    <td style={{ textAlign: "right" }}>{resInt.er_value}</td>
                                    <td style={{ textAlign: "right" }}>{resInt.er_rank}</td>
                                    <td style={{ textAlign: "right" }}>{resInt.er_diff}</td>
                                    <td style={{ textAlign: "right" }}>{resSec.er_value}</td>
                                    <td style={{ textAlign: "right" }}>{resSec.er_rank}</td>
                                </tr>
                            )
                        })

                    }
                </tbody>

            </table>

        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.resultAnalysis, nextProps.row.resultAnalysis)
    )
});